/* Imports */
import axios from "../api/api";
/* /Imports/ */

/* 
  Class: IncidentService
  Description: This class is responsible for incidents stuff.
*/
class IncidentService {
  /* 
    Obtain all incidents from the api.
  */
  getAllIncidents() {
    // return response.data;
    return axios.get("api/incidents", {
      headers: {
        Authorization: "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
      },
    }).then((response) => {
      return response.data;
    });
  }

  /* 
    Obtain user personal incidents from the api.
  */
  getMyIncidents(token) {
    return axios.get("api/incidents/user", {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      return response.data;
    });
  }

  /* 
    Obtain user team incidents from the api.
  */
  getTeamsIncidents(token) {
      return axios.get("api/incidents/user-teams", {
        headers: {
          Authorization: token,
        },
      }).then((response) => {
        return response.data;
      });
    }

  /* 
    Create new incident from the api.
  */
  createIncident(data) {
    return axios.post("api/incidents/create", data).then((response) => {
      return response.data;
    });
  }

  /* 
    Update certain incident from the api.
  */
  updateIncident(token, id, data) {
    return axios.post("api/incidents/" + id + "/update", data, {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      return response.data;
    });
  }

  /* 
    Delete certain incident from the api.
  */
  deleteIncident(id) {
    return axios.delete("api/incidents/" + id + "/delete", {
      headers: {
        Authorization:
          "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
      },
    }).then((response) => {
      return response.data;
    });
  }
}

export default new IncidentService();
